import { render } from "./TaxInformation.vue?vue&type=template&id=4f37529a&scoped=true"
import script from "./TaxInformation.vue?vue&type=script&lang=js"
export * from "./TaxInformation.vue?vue&type=script&lang=js"

import "./TaxInformation.vue?vue&type=style&index=0&id=4f37529a&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f37529a"]])

export default __exports__